var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplyToAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_284_6",
    "data-name": "Component 284 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16419",
    "data-name": "Rectangle 16419",
    width: 25,
    height: 25,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65866",
    "data-name": "Group 65866",
    transform: "translate(-4259.26 -298.443)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_-Product-Icons",
    "data-name": "\\uD83D\\uDD0D-Product-Icons",
    transform: "translate(4262.259 303.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_copy_move_24_regular",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Color",
    "data-name": "\\uD83C\\uDFA8-Color",
    d: "M9.891,2c1.305,0,.072.394,0,1.575H8.863a.788.788,0,0,0-.788.788V18.018a.788.788,0,0,0,.788.788h6.585a7.038,7.038,0,0,0,1.36,1.576H8.863A2.363,2.363,0,0,1,6.5,18.018V4.363A2.363,2.363,0,0,1,8.863,2Z",
    transform: "translate(-6.5 -2)",
    fill: "#102633"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_-Product-Icons-2",
    "data-name": "\\uD83D\\uDD0D-Product-Icons",
    transform: "translate(4258.91 297.943)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_fluent_copy_move_24_filled",
    transform: "translate(6.5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_-Color-2",
    "data-name": "\\uD83C\\uDFA8-Color",
    d: "M18.054,12.5a5.777,5.777,0,1,1-5.777,5.777A5.777,5.777,0,0,1,18.054,12.5Zm.824,2.719a.526.526,0,0,0-.6,0l-.073.061-.061.073a.526.526,0,0,0,0,.6l.061.073,1.728,1.728H14.9l-.094.009a.525.525,0,0,0-.422.422l-.009.094.009.094a.525.525,0,0,0,.422.422l.094.009h5.042l-1.73,1.73-.061.073a.525.525,0,0,0,.731.731l.073-.061,2.657-2.66.039-.053.044-.084.027-.087.01-.067v-.093l-.01-.067-.012-.045-.034-.082L21.646,18l-.039-.053-2.657-2.66ZM18.316,2A2.363,2.363,0,0,1,20.68,4.363v7.613a6.832,6.832,0,0,0-9.124,8.4H8.863A2.363,2.363,0,0,1,6.5,18.018V4.363A2.363,2.363,0,0,1,8.863,2Z",
    transform: "translate(-6.5 -2)",
    fill: "#102633"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyToAll);
export default __webpack_public_path__ + "static/media/applyToAll.ae0a34089233c8e6f8202c90d6c1ab1c.svg";
export { ForwardRef as ReactComponent };